import { ViewHook } from "phoenix_live_view";

const mobileNavBtnSelector = "#mobile-nav-btn";

// This is because the mobile nav is only shown at MD sizes, and this is the breakpoint for it.
// If we don't close it when the height reaches this point, then the nav content is displayed
// while the button is not visible.
const maxWidthForMobileNavShow = 768;

class MobileNav extends ViewHook {
  private mobileNavBtn?: HTMLButtonElement;

  private resizeObserver?: ResizeObserver;

  mounted() {
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onClickOutside = this.onClickOutside.bind(this);

    this.mobileNavBtn = document.querySelector(mobileNavBtnSelector) as HTMLButtonElement;

    if (!this.mobileNavBtn) {
      console.error("MobileNav: missing mobile nav button");
      return;
    }

    this.mobileNavBtn.addEventListener("click", this.onButtonClick);

    this.close();

    this.resizeObserver = new ResizeObserver(() => {
      if (document.documentElement.clientWidth >= maxWidthForMobileNavShow) {
        this.close();
      }
    });
  }

  updated() {
    this.destroyed();
    this.mounted();
  }

  destroyed() {
    this.close();

    this.mobileNavBtn?.removeEventListener("click", this.onButtonClick);
    this.mobileNavBtn = undefined;

    this.resizeObserver?.disconnect();
    this.resizeObserver = undefined;
  }

  private open() {
    this.mobileNavBtn?.classList.add("open");
    document.documentElement.classList.add("disable-body-scroll");

    this.el.removeAttribute("hidden");

    // In case the mobile nav was scrolled, go to the top
    this.el.scrollTop = 0;

    this.resizeObserver?.observe(this.el);

    document.addEventListener("click", this.onClickOutside);
  }

  private close() {
    this.mobileNavBtn?.classList.remove("open");
    document.documentElement.classList.remove("disable-body-scroll");

    this.el.setAttribute("hidden", "");

    this.resizeObserver?.disconnect();

    document.removeEventListener("click", this.onClickOutside);
  }

  private onButtonClick(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();

    if (this.mobileNavBtn?.classList.contains("open")) {
      this.close();
    } else {
      this.open();
    }
  }

  private onClickOutside(event: MouseEvent) {
    const target = event.target as Node;

    const isOutside = this.el && !this.el.contains(target);

    if (isOutside) {
      this.close();
    }
  }
}

export default MobileNav;
